import { Table } from "react-bootstrap";

const BusinessHours = ({ data = [] }) => {
  const getBusinessHoursOfDay = (day) => {
    const items = data.filter((i) => i.day_of_week === day);

    if (items.length === 0) {
      return "geschlossen";
    }

    return items
      .map((obj) => `${obj.start_time} - ${obj.end_time}`)
      .join(" / ");
  };

  return (
    <Table>
      <tbody>
        <tr>
          <th>Montag</th>
          <td>{getBusinessHoursOfDay(1)}</td>
        </tr>
        <tr>
          <th>Dienstag</th>
          <td>{getBusinessHoursOfDay(2)}</td>
        </tr>
        <tr>
          <th>Mittwoch</th>
          <td>{getBusinessHoursOfDay(3)}</td>
        </tr>
        <tr>
          <th>Donnerstag</th>
          <td>{getBusinessHoursOfDay(4)}</td>
        </tr>
        <tr>
          <th>Freitag</th>
          <td>{getBusinessHoursOfDay(5)}</td>
        </tr>
        <tr>
          <th>Samstag</th>
          <td>{getBusinessHoursOfDay(6)}</td>
        </tr>
        <tr>
          <th>Sonntag</th>
          <td>{getBusinessHoursOfDay(0)}</td>
        </tr>
      </tbody>
    </Table>
  );
};

export default BusinessHours;
